var exports = {
  "UX": "PlutoniumUpsell.module__upsell___cy12eH",
  "Kk": "PlutoniumUpsell.module__icon___cy12eH",
  "Qs": "PlutoniumUpsell.module__content___cy12eH",
  "Qq": "PlutoniumUpsell.module__text___cy12eH",
  "o1": "PlutoniumUpsell.module__actions___cy12eH",
  "R3": "PlutoniumUpsell.module__dismissLink___cy12eH",
};

module.exports = exports;
